import React, { useState } from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {Box, Button, CircularProgress} from '@material-ui/core';
import {DashboardStyles} from '../../../styles/dashboard';
import { useHistory } from 'react-router-dom';
import {connect} from 'react-redux';
import {MoneyFormatter} from "../../../shared/formatter";
import * as actions from "../../../store/actions";
import { PanelTabs } from '../../../store/actions/dashboard';

const useStyles = makeStyles(DashboardStyles);

const OfferDetail = (props) => {

    const classes = useStyles();
    const history = useHistory();
    const [offerState, setOfferState] = useState({ isAccepted: false });

    const selectedOfferId = props.match && props.match.params ? +props.match.params['id'] : null;
    const selectedOffer = props.selectedVehicle && props.selectedVehicle.offers ? 
        props.selectedVehicle.offers.find((offer) => +(offer.id) === selectedOfferId) : null;

    if (!selectedOffer) {
        history.push('dashboard');
        return null;
    }

    const handleConfirmation = () => {
        props.onConfirmOffer(selectedOffer.id, (err, data) => {
            if (err) {
                return ;
            }
            setOfferState({ 
                ...offerState,
                isAccepted: true
            });
        });
    }

    let body = null;
    if (offerState.isAccepted) {
        body = (
            <React.Fragment>
                <h3 className={classes.title}>Offer Accepted</h3>
                <Box className={classes.offerDetailOfferText}>{getCongrats(selectedOffer)}</Box>
                <Box className={classes.bottomControlBox}>
                    <Button className={classes.button} variant="contained" color="primary" component="span" size="medium" 
                        disabled={props.loading}
                        onClick={() => {
                            history.replace("/dashboard")
                        }}>Go To Dashboard</Button>
                </Box>
            </React.Fragment>
        );
    } else {
        body = (
            <React.Fragment>
                <h3 className={classes.title}>Offer Details</h3>
                <Box className={[classes.centeredFixedBox].join(' ')}>
                    <Box className={[classes.offerDetailVehicleBox].join(' ')}>
                        {props.selectedVehicle.year} {props.selectedVehicle.make} {props.selectedVehicle.model}</Box>
                    <Box className={[classes.offerDetailVinBox].join(' ')}>VIN: {String(props.selectedVehicle.vin).toUpperCase()}</Box>

                    <Box className={classes.offerDetailOfferTitle}>Offer</Box>
                    <Box className={[classes.offerDetailAmount].join(' ')}>{MoneyFormatter.format(selectedOffer.amount)}</Box>
                    <Box className={[classes.offerDetailByClient].join(' ')}>By: {selectedOffer.clientName}</Box>
                </Box>
                <Box className={classes.offerDetailOfferText}>When you accept the offer, your account representative
                will reach out to you for next steps to finalize the transaction.</Box>
                <Box className={classes.bottomControlBox}>
                    <Button className={classes.button} variant="outlined" color="primary" component="span" size="medium" 
                        disabled={props.loading}
                        onClick={() => {
                            props.expandOfferTab()
                            history.replace("/dashboard")
                        }}>Cancel</Button>
                    <Button className={classes.button} variant="contained" color="primary" component="span" size="medium" 
                        onClick={handleConfirmation} disabled={props.loading}>
                    {props.loading &&
                        <CircularProgress size={30} className={classes.buttonProgress} color="secondary"/>}Accept</Button>
                </Box>
            </React.Fragment>
        )
    }

    return (
        <Box className={[classes.box, classes.width94p].join(' ')}>
            {body}
        </Box>
    );
};

const getCongrats = (offer) => {
    const clientName = offer && offer.clientName ? String(offer.clientName).toLowerCase() : null;
    let res = null;
    if (clientName.indexOf('carvana') > -1) {
        res = `Great! Your Carwiser agent has been notified you’d like to move forward and will contact you as soon as possible.
        To get started in the meantime, please go to carvana.com and log in with your email as your username and carwiser123 as your password.
        If you click on the Sell/Trade button, you will be able to begin uploading owner verification documents.
        We’ll talk to you soon!`;
    } else if (clientName.indexOf('vroom') > -1) {
        res = `Great! Your Carwiser agent has been notified you’d like to move forward and will contact you as soon as possible. 
        To get started in the meantime, please click the link in your Vroom Offer email. You’ll be prompted to begin uploading owner verification documents. 
        We’ll talk to you soon!`;
    } else if (clientName.indexOf('shift') > -1) {
        res = `Great! Your Carwiser agent has been notified you’d like to move forward and will contact you as soon as possible. 
        To get started in the meantime, we’ll have to get an official evaluation scheduled. This can be done via the email containing your offer. Keep in mind, you’ll receive a $200 credit if you sell at the time of the evaluation.
        A representative from Shift will be giving you a call to verify information about the vehicle.
        We’ll talk to you soon!`;
    } else if (clientName.indexOf('driveway') > -1) {
        res = `Great! Your Carwiser agent has been notified you’d like to move forward and will contact you as soon as possible. 
        To move forward in the meantime, we’ll have to get an evaluation scheduled. This can be done via the email containing your offer
        A representative from Driveway will also be reaching out to help assist in the process.
        We’ll talk to you soon! `;
    } else if (clientName.indexOf('autonation') === -1) {
        res = `Great! Your Carwiser agent has been notified you’d like to move forward and will contact you as soon as possible. 
        We’ll provide you with a voucher to take into the dealership with you at the time of your appointment. Talk to you soon!`;
    } else {
        res = `Congrats on accepting your offer! Your account representative will be 
        reaching out to you ASAP!`;
    }

    return res;
}

const mapStateToProps = state => {
    return {
        loading: state.app.loading,
        selectedVehicle: state.app.selectedVehicle
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onConfirmOffer: (offerId, cb) => dispatch(actions.applyOffer(offerId, cb)),
        expandOfferTab: () => dispatch(actions.expandTabOnly(PanelTabs.offers))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(OfferDetail);